import { Link } from 'react-router-dom'

import routes from '../../../routers'

const AVATAR_COLORS = ['#fec925', '#57ad91', '#f7f5ad', '#e9b8a8']

// Tap a family group to share the recipe with it; tap again to stop sharing
const FamilyGroupPicker = ({ groups = [], value = [], onChange }) => {
  const selected = value || []

  if (!groups?.length) {
    return (
      <p className="familyPickerEmpty">
        You're not in a family group yet.{' '}
        {/* A new tab, so the recipe being written here isn't lost */}
        <Link to={`${routes.settings}#create-group`} target="_blank" rel="noopener noreferrer">
          Start one
        </Link>{' '}
        to share recipes with your family. You can also share this recipe later.
      </p>
    )
  }

  const toggle = (id) =>
    onChange(selected.includes(id) ? selected.filter((item) => item !== id) : [...selected, id])

  return (
    <div className="familyPicker">
      {groups.map(({ id, name }, index) => {
        const isOn = selected.includes(id)
        return (
          <label key={id} className={`familyPickerItem ${isOn ? 'selected' : ''}`}>
            <input type="checkbox" checked={isOn} onChange={() => toggle(id)} />
            <span
              className="familyPickerAvatar"
              style={{ backgroundColor: AVATAR_COLORS[index % AVATAR_COLORS.length] }}
              aria-hidden="true"
            >
              {(name || '?').trim().charAt(0).toUpperCase()}
            </span>
            <span className="familyPickerName">{name}</span>
            <span className="familyPickerCheck" aria-hidden="true">
              {isOn ? '✓' : ''}
            </span>
          </label>
        )
      })}
    </div>
  )
}

export default FamilyGroupPicker
